import React from "react";

import connectToStores from "alt-utils/lib/connectToStores";
import TicketStore from "../../stores/TicketStore";
import TicketButton from "./ticket-button.jsx";
import TicketListItem from "./ticket-list/ticket-list-item.jsx";
import PassStore from "../../stores/PassStore";
import PassActions from "../../actions/PassActions";
import PersonStore from "../../stores/PersonStore";
import OrderStore from "../../stores/OrderStore";
import OrderActions from "../../actions/OrderActions";

import {
  FlatButton,
  RaisedButton,
} from "material-ui";


class VirtualExpressTicketButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};

    this.getPassSalesOptions = this.getPassSalesOptions.bind(this);
    this.getUserTicketStatus = this.getUserTicketStatus.bind(this);
    this.submitOrder = this.submitOrder.bind(this);
  }

  static get contextTypes() {
    return {
      tenant: React.PropTypes.object,
      appSettings: React.PropTypes.object,
      muiTheme: React.PropTypes.object
    };
  }

  static getStores() {
    return [TicketStore, PassStore, OrderStore];
  }

  static getPropsFromStores() {
    return {};
  }

  componentWillMount() {
    PassActions.fetchAll.defer();
  }

  getStyles() {
    return {
      button: {}
    };
  }

  submitOrder() {
    const data = this.getPassSalesOptions();

    if (data) {
      const orderData = {
        event_bucket: this.props.event.event_bucket,
        pass: data.passId,
        subitems: [
          {
            ticket_bucket: data.passTicketBucketId,
            quantity: 1,
          },
        ],
      };
    
      OrderActions.updateCurrentOrder.defer(orderData);
      OrderActions.submitOrder.defer();
    }
    
  }

  getPassSalesOptions() {

    const passObject = PassStore.getPassesForCurrentEventBucket();
    const passBucketsAll = Object.keys(passObject).map(p => {
      return passObject[p].pass_bucket.id;
    });

    const passBuckets = passBucketsAll.filter((item, i, ar) => ar.indexOf(item) === i);

    // Determine if there is a pass that be used to order a free ticket to this
    // virtual screening. This will be used in the OTT apps to allow one-click
    // "unlock with pass" for free.
    const passSalesOptions = this.props.event.ticket_buckets
      .reduce((options, bucket) => {
        let newOptions = [];
        let hasApplicableBucket = false;
        for (let apb = 0; apb < bucket.applicable_pass_buckets.length; apb++) {
          let thisApplicableBucket = bucket.applicable_pass_buckets[apb];
          if (passBuckets.includes(thisApplicableBucket)) {
            hasApplicableBucket = thisApplicableBucket;
            break;
          }
        }

        if (bucket.public && bucket.quantity_remaining && bucket.price === 0 && hasApplicableBucket) {
          const applicablePassIds = Object.keys(passObject).reduce((arr, p) => {
            if (passObject[p].pass_bucket.id === hasApplicableBucket) {           
              arr.push(passObject[p].id);
            }
            return arr;
          }, []); 
          newOptions.push({
            ticket_bucket_id: bucket.id,
            pass: applicablePassIds[0]
          });
        }
        return options.concat(newOptions);
      }, [])
      .sort((a, b) => (!!a.pass === !!b.pass ? 0 : a.pass ? -1 : 1));

    let passId = null;
    let passTicketBucketId = null;

    if (passSalesOptions.length > 0) {
      passId = passSalesOptions[0].pass;
      passTicketBucketId = passSalesOptions[0].ticket_bucket_id;
    }

    if (passId === null) {
      return null;
    }

    return {
      passId,
      passTicketBucketId
    }
  };

  getUserTicketStatus() {
    //TODO check the users tickets for this event and see if they have an active ticket (or expired ticket)
    const ticketBuckets = this.props.event.ticket_buckets.map(tb => {
      return tb.id;
    });

    const tickets = TicketStore.getTicketsByEventId(this.props.event.id);

    let foundTicket = false;
    let hasValidTicket = false;
    let hasExpiredTicket = false;
    for (let t=0; t < tickets.length; t++) {
      const thisTicket = tickets[t];
      if (ticketBuckets.includes(thisTicket.ticket_bucket.id)) {
        // check valididty of date/time
        foundTicket = true;
        if (Date.now() < new Date(thisTicket.expires_at || thisTicket.unlocked_until)) {
          hasValidTicket = true;
          break;
        }
        else {

        }
      }
    }

    return {
      foundTicket: foundTicket,
      hasValidTicket: hasValidTicket
    };

  }

  render() {
    let styles = this.getStyles(),
      { event, appSettings } = this.props;

    let isVirtual = event.is_virtual;

    let isLoggedIn = PersonStore.isLoggedIn();
    if (!isLoggedIn || !isVirtual) {
      return null;
    }

    let hasTicketOption = this.getPassSalesOptions();
    let ticketStatus = this.getUserTicketStatus();

    // handles the case where the user has a valid ticket but no ticket options are 
    // currently available - they can still watch but all others should be blocked
    if (!hasTicketOption && !ticketStatus.hasValidTicket) {
      console.log("EE Virtual Express Button WILL NOT RENDER: No available ticket option");
      return null;
    }

    let isPastAvailabilityWindow =
      event.end_time &&
      Date.now() > new Date(event.start_time) &&
      Date.now() > new Date(event.end_time);

    let isPastWatchWindow =
      event.end_time &&
      event.virtual_intervals &&
      event.virtual_intervals.watch_interval &&
      Date.now() > new Date(event.start_time) &&
      Date.now() > new Date(event.end_time).getTime() + event.virtual_intervals.watch_interval;

    // handle cutoff at availability endpoint
    if (
      event.end_time &&
      event.cutoff_event_watch_at_availability_end &&
      Date.now() > new Date(event.end_time)
    ) {
      isPastAvailabilityWindow = true;
      isPastWatchWindow = true;
    }

    let eventInFuture = false;
    if (event.start_time && (Date.now() < new Date(event.start_time))) {
      eventInFuture = true;
    }
    let eventInPast = false;
    if (event.end_time && (Date.now() > new Date(event.end_time))) {
      eventInPast = true;
    }

    let buttonLabel = "";
    let buttonDisabled = false;
    if (eventInFuture) {
      buttonLabel = "CONTENT UNAVAILABLE";
      buttonDisabled = true;
    }
    else if (eventInPast) {
      if (isPastAvailabilityWindow && !isPastWatchWindow && ticketStatus.foundTicket && ticketStatus.hasValidTicket) {
        buttonLabel = "WATCH NOW";
      }
      else {
        buttonLabel = "CONTENT UNAVAILABLE"
        buttonDisabled = true;
      }
    }
    else if (ticketStatus.foundTicket && !ticketStatus.hasValidTicket) {
      buttonLabel = "EXPIRED";
      buttonDisabled = true;
    }
    else if (ticketStatus.foundTicket && ticketStatus.hasValidTicket) {
      buttonLabel = "WATCH NOW";
    }
    else {
      buttonLabel = "UNLOCK NOW";
    }

    return (
      <div
        className="eventive__ticket-button__container eventive__virtual-express-ticket-button__container"
        data-button-mode="virtual"
      >
        <RaisedButton
          className="eventive__virtual-express-ticket-button__button"
          label={buttonLabel}
          labelStyle={{ textTransform: "initial" }}
          onClick={ticketStatus.foundTicket && ticketStatus.hasValidTicket ? 
            this.props.consumePlayAction
              ? () => {
                  this.props.onAction({
                    target: {
                      event_id: event.id
                    },
                    action: "play"
                  });
                }
              : undefined
            : this.submitOrder}
          disabled={buttonDisabled}
        />
      </div>
    );
  }
}

export default connectToStores(VirtualExpressTicketButton);



// WEBPACK FOOTER //
// ./src/app/components/partials/virtual-express-ticket-button.jsx